var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-header"},[_c('div',{staticClass:"brand-row"},[_c('img',{staticClass:"brand-logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":""}}),_c('div',{staticClass:"header-brand"},[_vm._v("OP "),_c('span',[_vm._v("Card"),_c('em',[_vm._v("X")])])])])])
}]

export { render, staticRenderFns }